import { FC } from 'react';

import RequestCallbackModal from '@/components/ContactHeader/RequestCallbackModal';
import { HeaderDropdowns } from '@/components/Header/HeaderDropdowns';
import ShortListModalContent from '@/components/ShortListModalContent';
import { IDatePickerDictonary } from '@/dictionaries/components/datePicker/types';
import { IEnquiryFormDictionary } from '@/dictionaries/components/enquiryForm/types';
import { IHeaderDictionary } from '@/dictionaries/components/header/types';
import { IModalsDictionary } from '@/dictionaries/components/modals/types';
import { ISendToFriendsFormDictionary } from '@/dictionaries/components/SendToFriendsForm/types';
import { IContactPageDictionary } from '@/dictionaries/pages/contacts/types';
import { ICountriesDictionary } from '@/dictionaries/utils/countries/types';
import { ISlugDictionary } from '@/dictionaries/utils/slugs/types';
import { IURLDictionary } from '@/dictionaries/utils/url/types';
import { cn } from '@/lib/utils';
import { MdOutlinePhone, MdPhoneCallback } from 'react-icons/md';

interface HeaderSelectProps {
  dict: IHeaderDictionary;
  urlDict: IURLDictionary;
  slugsDict: ISlugDictionary;
  contactUsDict: IContactPageDictionary;
  countriesDict: ICountriesDictionary;
  lang: Locale;
  atFooter?: boolean;
  phone: string;
  modalsDict: IModalsDictionary;
  enquiryFormDict: IEnquiryFormDictionary;
  sendToFriendFormDict: ISendToFriendsFormDictionary;
  datePickerDict: IDatePickerDictonary;
  isActive?: boolean;
}

const HeaderSelect: FC<HeaderSelectProps> = ({
  dict,
  urlDict,
  slugsDict,
  contactUsDict,
  countriesDict,
  lang,
  phone,
  modalsDict,
  enquiryFormDict,
  sendToFriendFormDict,
  datePickerDict,
  isActive = false,
}) => {
  return (
    <>
      <div
        className={cn(
          'flex flex-col mobileL:flex-row desktop:items-center gap-6 desktop:gap-0 transition-colors',
        )}>
        <div className="relative flex flex-row desktop:px-2 xl:px-[0.9375rem] gap-4 items-center justify-center">
          <div className="flex items-center gap-3">
            <MdOutlinePhone
              width={16}
              height={16}
              className={cn(
                'desktop:hidden',
                isActive ? 'fill-black/90' : 'fill-white',
              )}
            />
            <a
              href={`tel:${phone.replace(/ /g, '')}`}
              className="text-sm whitespace-nowrap"
              title="Contact Us">
              {phone}
            </a>
          </div>

          <Divider isActive={isActive} />

          {/* <div className="flex items-center">
            <RequestCallbackModal
              lang={lang}
              dict={contactUsDict}
              countriesDict={countriesDict}>
              <div>
                <MdPhoneCallback
                  width={16}
                  height={16}
                  className={cn(
                    `cursor-pointer hover:scale-110 transition-transform duration-300 ease-in-out`,
                    isActive ? 'fill-black/90' : 'fill-white',
                  )}
                />
              </div>
            </RequestCallbackModal>
          </div>

          <Divider isActive={isActive} /> */}

          <div className="hidden desktop:flex items-center">
            <ShortListModalContent
              dict={modalsDict}
              lang={lang}
              enquiryFormDict={enquiryFormDict}
              sendToFriendFormDict={sendToFriendFormDict}
              countriesDict={countriesDict}
              datePickerDict={datePickerDict}
            />
          </div>
        </div>

        <div className="relative desktop:px-2 flex gap-2">
          <HeaderDropdowns lang={lang} dict={dict} slugsDict={slugsDict} />
        </div>
      </div>
    </>
  );
};

function Divider({ isActive }: { isActive: boolean }) {
  return (
    <div
      className={cn(
        'h-6 w-px bg-white opacity-80 hidden mobileL:block my-auto',
        isActive && 'bg-black/90',
      )}
    />
  );
}

export default HeaderSelect;
